import { Container, Col, Row } from "react-bootstrap";
import Footer from "../../components/Layout/Footer/Footer";
import "../../components/Layout/Jumbotron/JumbotronII";
import "./bio.css";
import TonyBio from "./Tony";

const Bio = () => {
  return (
    <div>
      <Container className="JumboBGII" fluid>
        <div className="OverlayII">
          <Row>
            <Col className="text-center">
              <h1>BIO</h1>
            </Col>
          </Row>
        </div>
      </Container>
      <TonyBio />
      <Footer />
    </div>
  );
};

export default Bio;
